import RestClient from './RestClient';
import { Comment } from '../models';

class Comments extends RestClient {
    constructor() {
        super({
            // rest config
            model: Comment,
            entryPoint: 'comments',
            sortBy: 'createdAt',
            id_field: '_id',
            // redux config
            resource: 'comment',
            resources: 'comments',
        });
    }

    toggleReaction(commentId: string, emoji: string) {
        return this.PUT(`/${this.entryPoint}/${commentId}/reactions`, { emoji })
            .then(response => response.json())
            .then(json => {
                if (json.comment) {
                    json.comment = new Comment(json.comment);
                    return json;
                }
                throw new Error(json.err || json.flash?.error || 'Unable to toggle reaction');
            });
    }
}

const CommentsApi = new Comments();
export default CommentsApi;
